import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Key } from "react-aria";
import { Tab, TabList, Tabs } from "react-aria-components";

export function IconToggleTabBar({
  children,
  className,
  defaultValue,
  value,
  onChange,
}: React.PropsWithChildren<{
  className?: string;
  defaultValue?: Key;
  value?: Key;
  onChange?: (key: Key) => void;
}>) {
  return (
    <Tabs
      orientation='horizontal'
      defaultSelectedKey={defaultValue}
      onSelectionChange={onChange}
      selectedKey={value}
      className={className}
    >
      <TabList className='tw-flex tw-gap-2'>{children}</TabList>
    </Tabs>
  );
}

function IconToggleTabBarTab({
  children,
  id,
  icon,
}: React.PropsWithChildren<{
  id: Key;
  icon: IconDefinition;
}>) {
  return (
    <Tab id={id}>
      {({ isSelected }) => (
        <div
          className={classNames(
            "tw-flex tw-h-[34px] tw-items-center tw-gap-1 tw-rounded-md tw-px-3 tw-py-2 tw-transition-colors tw-duration-75",
            {
              "tw-cursor-pointer hover:tw-bg-[#0000000e] active:tw-bg-[#00000023]": !isSelected,
              "tw-select-none tw-bg-[#F5FBFE] tw-text-primary tw-ring-1 tw-ring-[#BADFF6]": isSelected,
            },
          )}
        >
          <FontAwesomeIcon icon={icon} />
          {isSelected && <div className='tw-font-bold'>{children}</div>}
        </div>
      )}
    </Tab>
  );
}

IconToggleTabBar.Tab = IconToggleTabBarTab;
